module.exports = __webpack_public_path__ + "static/media/Kochava.c9cdd3ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/roi/Kochava.png
// module id = 3307
// module chunks = 0